// extracted by mini-css-extract-plugin
export default {"trigger":"trigger-QNrAL","popover":"popover-q3Dhv","triggerWide":"triggerWide-BArlP","popoverWide":"popoverWide-MKKpL"};